module.exports = __webpack_public_path__ + "static/media/anatomia.1a5b473e.png";